var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-tip"},[_c('a-popover',{attrs:{"title":_vm.title,"content":_vm.content,"overlayStyle":{ maxWidth: '200px' },"placement":_vm.placement,"arrowPointAtCenter":""}},[_c('a-icon',{attrs:{"type":"info-circle"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }